import { Box, Flex, Text } from '@chakra-ui/react'
import { motion } from 'framer-motion'

interface StepProgressProps {
  currentStep: number
  totalSteps: number
}

const STEP_LABELS = ['Brand Analysis', 'Intelligence', 'Graphics']

export default function StepProgress({
  currentStep,
  totalSteps
}: StepProgressProps) {
  return (
    <Flex
      justifyContent="center"
      position="fixed"
      top="24px"
      left="50%"
      transform="translateX(-50%)"
      zIndex={10}
    >
      <Flex
        gap="4px"
        bg="rgba(10, 10, 15, 0.6)"
        backdropFilter="blur(20px) saturate(180%)"
        borderRadius="9999px"
        border="1px solid"
        borderColor="border.subtle"
        p="4px"
        alignItems="center"
      >
        {Array.from({ length: totalSteps }, (_, i) => {
          const isActive = i === currentStep
          const isCompleted = i < currentStep
          const label = STEP_LABELS[i] ?? `Step ${i + 1}`

          return (
            <Box key={i} position="relative" px="16px" py="8px" borderRadius="9999px">
              {isActive && (
                <motion.div
                  layoutId="active-step-bg"
                  style={{
                    position: 'absolute',
                    inset: 0,
                    borderRadius: '9999px',
                    background: 'rgba(0, 112, 243, 0.15)',
                    border: '1px solid rgba(0, 112, 243, 0.3)'
                  }}
                  transition={{ type: 'spring', stiffness: 400, damping: 30 }}
                />
              )}
              <Text
                position="relative"
                zIndex={1}
                textStyle="bodySuperSmall"
                fontWeight={isActive ? 500 : 400}
                color={
                  isActive
                    ? 'accent.400'
                    : isCompleted
                      ? 'white'
                      : 'whiteAlpha.700'
                }
                transition="color 0.3s ease"
                whiteSpace="nowrap"
              >
                {label}
              </Text>
            </Box>
          )
        })}
      </Flex>
    </Flex>
  )
}
